export class VideoConsultantFormModel {
  agreement: boolean;
  firstName: string;
  queueName: string;
}
